import { render, staticRenderFns } from "./product_audit_list.vue?vue&type=template&id=c4ca29de&scoped=true"
import script from "./product_audit_list.vue?vue&type=script&lang=js"
export * from "./product_audit_list.vue?vue&type=script&lang=js"
import style0 from "./product_audit_list.vue?vue&type=style&index=0&id=c4ca29de&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ca29de",
  null
  
)

export default component.exports